import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { logout } from 'actions';
import styles from './NavNotLoggedIn.css';

class NavNotLoggedIn extends React.Component {
  _logout = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.dispatch(logout());
  };

  render() {
    const { location } = this.props;
    const showSignout =
      location.pathname === '/kyb' || location.pathname === '/business-info';

    return (
      <div
        className={`navbar-collapse collapse header-login ${styles.wrapper}`}
        id="NavNotLoggedIn"
      >
        <ul
          className={`nav navbar-nav mk-navbar-nav navbar-right text-center ${
            styles['list-menu']
          }`}
        >
          <li>
            <a
              href="https://mokaposhelp.zendesk.com/hc/id"
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
            >
              help
            </a>
          </li>
          {!showSignout ? (
            <li>
              <Link
                to="/login"
                data-toggle="collapse"
                data-target=".navbar-collapse.in"
              >
                Sign In
              </Link>
            </li>
          ) : (
            <li>
              <Link
                to="#"
                onClick={this._logout}
                data-toggle="collapse"
                data-target=".navbar-collapse.in"
              >
                Sign Out
              </Link>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default connect()(NavNotLoggedIn);
